import React from 'react';
import { RandomCssDemo } from './RandomCssDemo';
import { makePoemWords } from './utils';

const POEM_HTML = `<div class="poem">${makePoemWords([
  'The',
  'serpent',
  'stared',
  'in',
  'surprise',
  'at',
  'this',
  'interloper.',
  'but',
  'God',
  'said:',
  '"You',
  'see',
  'this',
  'apple?"',
  'I',
  'squeeze',
  'it',
  'and',
  'look-cider."',
])}</div>`;

const POEM_SCAFFOLD = `
  * { box-sizing: border-box; }
  html { overflow: hidden; }
  body {
    margin: 0;
    min-height: 100vh;
    background: #e9e0cb;
    display: grid;
    place-items: center;
    padding: 2rem;
    font-family: "Courier Prime", ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    color: #181515;
  }

  .poem {
    width: min(42rem, 100%);
  }

  .poem span {
    font-size: 2rem;
  }
`;

export function PoemDiscreteExample() {
  return (
    <RandomCssDemo
      title="Poem: Discrete random() Toggle"
      htmlBody={POEM_HTML}
      showLoadButton={false}
      scaffoldCss={POEM_SCAFFOLD}
      cssCodeInit={`@property --discrete-number {
  syntax: "<integer>";
  inherits: false;
  initial-value: 0;
}

.poem span {
  --discrete-number: random(0, 1, 1);
  display: if(
    style(--discrete-number: 1): inline-block;
    else: block;
  );
}`}
    />
  );
}

export function PoemVisualExample() {
  return (
    <RandomCssDemo
      title="Poem: Weighted Visual Layout"
      htmlBody={POEM_HTML}
      showLoadButton={false}
      scaffoldCss={POEM_SCAFFOLD}
      cssCodeInit={`@property --discrete-number {
  syntax: "<integer>";
  inherits: false;
  initial-value: 0;
}

.poem span {
  --discrete-number: random(0, 10, 1);
  display: if(
    style(--discrete-number > 2): inline-block;
    else: block;
  );
  margin-left: if(
    style(--discrete-number < 2): random(0rem, 6rem);
    else: 0;
  );
  font-weight: if(
    style(--discrete-number > 5): random(400, 800);
    else: 400;
  );
}`}
    />
  );
}
